import { useRollbar } from '@rollbar/react';
import { useCallback } from 'react';

export const useErrorTrackingSystem = () => {
  const send = useSendTrackingSystem('error');
  return { send };
};

export const useWarningTrackingSystem = () => {
  const send = useSendTrackingSystem('warning');
  return { send };
};

type MethodKeys<T> = {
  [K in keyof T]: T[K] extends Function ? K : never;
}[keyof T]; // 結果のオブジェクトの値をUnionにする（neverはUnionから除外される）

type RollbarMethod = Extract<
  MethodKeys<ReturnType<typeof useRollbar>>,
  'error' | 'warning'
>;

const useSendTrackingSystem = (method: RollbarMethod) => {
  const rollbar = useRollbar();
  return useCallback(
    (error: Error | string) => {
      try {
        rollbar[method](error);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
    [method, rollbar]
  );
};
